import { type MapBounds } from '@/packages/redux-state/store/slices/mapConfiguration/slice';

type SearchCoors = [lng: number, lat: number];

type SearchBBox = [topLeft: SearchCoors, bottomRight: SearchCoors];

/**
 * Преобразует bbox в формате [topLeft, bottomRight], где координаты в формате [lng, lat]
 * в формат Ymaps.MapBounds [bottomLeft, topRight], где координаты в формате [lat, lng]
 * @param  {SearchBBox} bbox - координаты в формате поискового стандартрном для поиска Циан
 * @returns  {MapBounds} - bbox в формате Ymaps
 */
export const convertBboxToMapBounds = (bbox: SearchBBox): MapBounds => {
  const [[lngMin, latMax], [lngMax, latMin]] = bbox;

  return [
    [latMin, lngMin],
    [latMax, lngMax],
  ];
};
